export default __webpack_public_path__ + "static/media/pdficon.4a9d9967.svg";